export default "__VITE_ASSET__UcEtfNAP__"